import React, { useEffect, useRef, useState } from 'react';
import '../styles/BannersDash.css';
import { FaPlusCircle, FaSearch } from 'react-icons/fa';
import { RiCheckFill, RiCloseFill, RiFileShield2Line, RiToggleFill, RiToggleLine, RiArrowUpSLine, RiArrowDownSLine, RiDeleteBin6Line } from 'react-icons/ri';
import { useSlideout } from '../../../hooks/SlideoutContext';
import axios from 'axios';
import config from '../../../constants/config';
import { IoMdRefresh } from 'react-icons/io';
import { useOutletContext } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useToast } from '../../../hooks/ToastContext';

export default function BannersDash() {
    const { account } = useOutletContext() || {};
    const [cookies] = useCookies(["account-canto"]);
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(false);
    const { openSlideout, closeSlideout } = useSlideout();
    const { showToast } = useToast();

    useEffect(() => {
        fetchBanners()
    }, [])

    const fetchBanners = () => {
        setLoading(true);
        
        axios.post(config.api.url + 'admin/banners/fetch', {}, {
            crossdomain: true,
            headers: {
                'api': config.api.key,
                'auth': account?.auth_token || cookies['account-canto'],
            }
        })
        .then((json) => {
            const { success, response, data } = json.data;

            if(success){
                setBanners(data);
            } else {
                console.log(response)
            }
            setLoading(false);
        })
        .catch(function (error) {
            console.error("Fetch error:", error);
            setLoading(false);
        });
    }

    const EditBanner = ({ banner, fetchBanners }) => {
        const { closeSlideout } = useSlideout();
        const [bannerData, setBannerData] = useState({
            id: banner.id,
            title: banner.title,
            subtitle: banner.subtitle,
            button: banner.button,
            c2a: banner.c2a,
            active: banner.active === 1,
            image: banner.image
        });

        const [selectedImageFile, setSelectedImageFile] = useState(null);
        const [selectedImagePreview, setSelectedImagePreview] = useState(banner.image);
        const fileInputRef = useRef(null);
        
        // For logo image
        const [selectedLogoFile, setSelectedLogoFile] = useState(null);
        const [selectedLogoPreview, setSelectedLogoPreview] = useState(banner.logo || '');
        const [deleteLogo, setDeleteLogo] = useState(false);
        const logoFileInputRef = useRef(null);

        // Handle input changes
        const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setBannerData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));
        };

        // Handle file selection
        const handleImageChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                const imageUrl = URL.createObjectURL(file); // Create a temporary preview
                setSelectedImageFile(file);
                setSelectedImagePreview(imageUrl);
            }
        };
        
        // Handle logo file selection
        const handleLogoChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                const imageUrl = URL.createObjectURL(file); // Create a temporary preview
                setSelectedLogoFile(file);
                setSelectedLogoPreview(imageUrl);
            }
        };

        // Open file input
        const handleSelectImage = () => {
            fileInputRef.current.click();
        };
        
        // Open logo file input
        const handleSelectLogo = () => {
            logoFileInputRef.current.click();
        };
        
        // Handle logo deletion
        const handleDeleteLogo = () => {
            setSelectedLogoPreview('');
            setSelectedLogoFile(null);
            setDeleteLogo(true);
        };

        // Handle save changes
        const handleSaveChanges = () => {
            const formData = new FormData();
            
            // Check if this is an update or a new item
            const isNewItem = !bannerData.id;
            
            // Only append ID if it's an update
            if (!isNewItem) {
                formData.append("id", bannerData.id);
            }
            
            formData.append("title", bannerData.title);
            formData.append("subtitle", bannerData.subtitle);
            formData.append("button", bannerData.button);
            formData.append("c2a", bannerData.c2a);
            
            if (!isNewItem) {
                formData.append("active", bannerData.active ? 1 : 0);
            }
            
            if (selectedImageFile) {
                formData.append("image", selectedImageFile);
            }
            
            if (selectedLogoFile) {
                formData.append("logo", selectedLogoFile);
            }
            
            // Send flag to delete logo if requested
            if (deleteLogo) {
                formData.append("delete_logo", "1");
            }
            
            // Determine the endpoint based on whether it's a new item or an update
            const endpoint = isNewItem 
                ? "admin/banner/add" 
                : "admin/banners/update";
            
            axios.post(config.api.url + endpoint, formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: account?.auth_token || cookies['account-canto'],
                    "Content-Type": "multipart/form-data"
                }
            })
            .then((json) => {
                const { success, response } = json.data;
                if (success) {
                    closeSlideout();
                    fetchBanners();
                } else {
                    console.log("Error:", response);
                }
            })
            .catch((error) => {
                console.error(isNewItem ? "Add error:" : "Update error:", error);
            });
        };

        return (
            <div className="EditBannerContainer">
                <div className="EditBannerForm">
                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Title</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="title" 
                                value={bannerData.title} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Subtitle</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="subtitle" 
                                value={bannerData.subtitle} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Button Text</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="button" 
                                value={bannerData.button} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Button Link</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="c2a" 
                                value={bannerData.c2a} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Banner Image</div>
                        <div className="EditBannerOptionContent">
                            <div 
                                className="EditBannerImagePreview" 
                                style={{ backgroundImage: `url(${selectedImagePreview})` }}
                                onClick={handleSelectImage}
                            ></div>
                            <input 
                                type="file" 
                                ref={fileInputRef} 
                                style={{ display: 'none' }} 
                                onChange={handleImageChange} 
                                accept="image/*"
                            />
                            <div className="EditBannerImageText">Click to change image</div>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Logo Image (Optional)</div>
                        <div className="EditBannerOptionContent">
                            <div 
                                className="EditBannerImagePreview" 
                                style={{ backgroundImage: `url(${selectedLogoPreview})` }}
                                onClick={handleSelectLogo}
                            ></div>
                            <input 
                                type="file" 
                                ref={logoFileInputRef} 
                                style={{ display: 'none' }} 
                                onChange={handleLogoChange} 
                                accept="image/*"
                            />
                            <div className="EditBannerImageText">Click to change logo</div>
                            {selectedLogoPreview && (
                                <button 
                                    className="EditBannerDeleteButton" 
                                    onClick={handleDeleteLogo}
                                    type="button"
                                >
                                    <RiDeleteBin6Line style={{ fontSize: 14 }} />
                                    Remove Logo
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="EditBannerActions">
                        <button 
                            className="EditBannerSaveButton" 
                            onClick={handleSaveChanges}
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp * 1000);
        return date.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
        });
    };

    const moveItem = (index, direction) => {
        setBanners((prev) => {
            const newList = [...prev];
            const targetIndex = index + direction;
            if (targetIndex < 0 || targetIndex >= newList.length) return prev;
            const temp = newList[index];
            newList[index] = newList[targetIndex];
            newList[targetIndex] = temp;
            return newList;
        });
    };

    const saveOrder = () => {
        if (loading) return;
        setLoading(true);
        const order = banners.map(b => b.id);
        axios.post(`${config.api.url}admin/banners/reorder`, { order }, {
            crossdomain: true,
            headers: {
                api: config.api.key,
                auth: account?.auth_token || cookies['account-canto']
            }
        }).then((res) => {
            const { success, response } = res.data;
            if (!success) {
                showToast({ 
                    message: 'Failed to save order: ' + (response || 'Unknown error'), 
                    type: 'error' 
                });
            } else {
                fetchBanners();
                showToast({ 
                    message: 'Banner order saved successfully!', 
                    type: 'success' 
                });
            }
            setLoading(false);
        }).catch((err) => {
            console.error('Reorder error:', err);
            showToast({ 
                message: 'Error saving order. Please try again.', 
                type: 'error' 
            });
            setLoading(false);
        });
    };

    const toggleBannerStatus = (bannerId, currentStatus) => {
        // Handle both string and number values
        const newStatus = (currentStatus == 1 || currentStatus === "1") ? 0 : 1;
        
        const formData = new FormData();
        formData.append('id', bannerId);
        formData.append('status', newStatus);

        axios.post(config.api.url + 'admin/banner/toggle', formData, {
            crossdomain: true,
            headers: {
                'api': config.api.key,
                'auth': account?.auth_token || cookies['account-canto'],
            }
        })
        .then((json) => {
            const { success, response } = json.data;
            if (success) {
                fetchBanners(); // Refresh the list
            } else {
                console.error("Toggle error:", response);
            }
        })
        .catch((error) => {
            console.error("Toggle error:", error);
        });
    };

    return (
        <div className='BannersDash'>
            <div className='BannersHeader'>
                <div className='BannersHeaderTitle'>
                    <h1>Banners</h1>
                    <p>Manage banners that appear on your website</p>
                </div>
                <div className='BannersHeaderActions'>
                    <button className='BannersRefreshButton' onClick={fetchBanners}>
                        <IoMdRefresh />
                        <span>Refresh</span>
                    </button>
                    <button 
                        className='BannersAddButton'
                        onClick={() => {
                            openSlideout({
                                title: 'Add New Banner',
                                content: <EditBanner 
                                    banner={{
                                        id: '',
                                        title: '',
                                        subtitle: '',
                                        button: '',
                                        c2a: '',
                                        image: '',
                                        active: 1
                                    }} 
                                    fetchBanners={fetchBanners}
                                />
                            });
                        }}
                    >
                        <FaPlusCircle />
                        <span>Add New</span>
                    </button>
                    <button 
                        className='BannersAddButton'
                        onClick={saveOrder}
                        disabled={loading}
                    >
                        <span>Save Order</span>
                    </button>
                </div>
            </div>

            <div className='BannersContent'>
                <div className='BannersContentNavigation'>
                    <div className='BannersContentNavigationItem Active'>Active</div>
                    <div className='BannersContentNavigationItem Image'>Image</div>
                    <div className='BannersContentNavigationItem Title'>Title</div>
                    <div className='BannersContentNavigationItem Subtitle'>Subtitle</div>
                    <div className='BannersContentNavigationItem Date'>Date</div>
                </div>
                <div className='BannersScroll'>
                    {banners.map((banner, index) => {
                        return (
                            <div className='BannerItem' key={banner.id}>
                                <div className="BannerItemDetailsText First Active">
                                    <span className={`BannerItemDetailsTextOption Circle ${banner.active > 0 ? 'Success' : 'Error'}`}>
                                        {banner.active > 0
                                        ? <RiCheckFill style={{ fontSize: 12 }} />
                                        : <RiCloseFill style={{ fontSize: 12 }} />
                                        }
                                    </span>
                                </div>
                                <div className="BannerItemDetailsText Image">
                                    <div 
                                        className="BannerItemDetailsTextImage" 
                                        style={{ backgroundImage: `url(${banner.image})` }} 
                                    />
                                </div>
                                <div className="BannerItemDetailsText Title Bold">{banner.title}</div>
                                <div className="BannerItemDetailsText Subtitle">{banner.subtitle}</div>
                                <div className="BannerItemDetailsText Date">{banner.timestamp_last}</div>

                                <div className="BannerItemOptions">
                                    <a 
                                        onClick={() => toggleBannerStatus(banner.id, banner.active)} 
                                        className={`BannerItemOptionsButton ${banner.active == "1" ? 'DeleteInverted' : 'AddInverted'}`}
                                    >
                                        {banner.active
                                        ? <RiToggleFill style={{ fontSize: 14 }} />
                                        : <RiToggleLine style={{ fontSize: 14 }} />
                                        }
                                        <span className="BannerItemOptionsButtonText">
                                            {banner.active == "1" ? 'Deactivate' : 'Activate'}
                                        </span>
                                    </a>

                                    <a 
                                        onClick={() => moveItem(index, -1)}
                                        className="BannerItemOptionsButton Edit"
                                    >
                                        <RiArrowUpSLine style={{ fontSize: 16 }} />
                                        <span className="BannerItemOptionsButtonText">Up</span>
                                    </a>
                                    <a 
                                        onClick={() => moveItem(index, 1)}
                                        className="BannerItemOptionsButton Edit"
                                    >
                                        <RiArrowDownSLine style={{ fontSize: 16 }} />
                                        <span className="BannerItemOptionsButtonText">Down</span>
                                    </a>

                                    <a 
                                        onClick={() => {
                                            openSlideout({
                                                title: 'Edit Banner',
                                                content: <EditBanner banner={banner} fetchBanners={fetchBanners}/>
                                            });
                                        }} 
                                        className="BannerItemOptionsButton Edit"
                                    >
                                        <RiFileShield2Line style={{ fontSize: 14 }} />
                                        <span className="BannerItemOptionsButtonText">Edit</span>
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className='BannersPaginationWrapper'>
                    {/* Pagination will be added here when needed */}
                </div>
            </div>
        </div>
    );
}
